import { SpaceProvider } from '@ably/spaces/dist/mjs/react/contexts/SpaceContext';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import ChannelProvider from '@/channels/ChannelProvider';
import AppContext from '@/contexts/appContext';
import Container from '@/ui/components/Container';
import { healthieLink } from '@/utils/healthieLinks';

import BillingReportResultApp from './BillingReportResultApp';

function BillingApp() {
  const { billingReportId, reportResultId } = useParams<{
    billingReportId: string;
    reportResultId: string;
  }>();
  const { currentUser, permissions, host } = useContext(AppContext);

  if (!billingReportId || !reportResultId) {
    return <div className="p-4 text-red-600">Error: No report ID provided</div>;
  }

  if (!currentUser || !permissions) {
    return <div className="p-4 text-red-600">Error: No user logged in</div>;
  }

  const channelName = `enc:billing-report-${billingReportId}-${reportResultId}`;

  return (
    <Container type="full-width-page">
      <ChannelProvider channelName={channelName}>
        <SpaceProvider name={`billing-report-${reportResultId}-space`}>
          <BillingReportResultApp
            billing_report_id={billingReportId}
            billing_report_result_id={reportResultId}
            healthie_url={healthieLink({ host })}
            user={currentUser}
            permissions={permissions}
          />
        </SpaceProvider>
      </ChannelProvider>
    </Container>
  );
}

export default BillingApp;
